import theme from 'theme'
import colors from 'theme/ui/colors'
import { scales, variants } from './types'

export const buttonSizes = {
  LARGE: 'large',
  SMALL: 'small',
} as const

const disabledButtonStyles = {
  background: theme.colors.bg_surface_secondary,
  color: theme.colors.textSubtle,
}

export const base = {
  [buttonSizes.LARGE]: {
    height: '44px !important',
    minHeight: '44px !important',
    minWidth: '160px !important',
    padding: `${theme.spacing.fix_150} ${theme.spacing.fix_300} !important`,
    borderRadius: theme.radii.radius_lg,
    fontSize: `${theme.typography.fontSizes.label_lg} !important`,
    fontWeight: theme.typography.fontWeights.semibold,
    color: theme.colors.fg_primary,
    textAlign: 'center',
    lineHeight: 'normal !important',

    '&:disabled': {
      ...disabledButtonStyles,
    },
  },
  [buttonSizes.SMALL]: {
    height: '32px !important',
    minHeight: '32px !important',
    minWidth: '120px !important',
    padding: `${theme.spacing.fix_100} ${theme.spacing.fix_150} !important`,
    borderRadius: theme.radii.radius_md,
    fontSize: `${theme.typography.fontSizes.label} !important`,
    fontWeight: theme.typography.fontWeights.semibold,
    color: theme.colors.fg_primary,
    textAlign: 'center',
    lineHeight: 'normal !important',

    '&:disabled': {
      ...disabledButtonStyles,
    },
  },
} // TODO REMOVE '!important'after remove old version

export const styleVariants = {
  [variants.PRIMARY]: {
    background: colors.gradient.primaryAlt,
    color: 'text',
  },
  [variants.TEXT]: {
    background: 'transparent',
    color: 'text',

    '&:disabled': {
      background: 'transparent !important',
      borderColor: 'transparent !important',
    },
  },
  [variants.SECONDARY]: {
    backgroundColor: '#1D2533',
    boxShadow: 'none',
    color: 'text',
    ':disabled': {
      backgroundColor: 'transparent',
    },
  },
  [variants.ROUND]: {
    width: '100%',
    border: 0,
    borderRadius: '40px',
    color: 'text',
    background: 'transparent',
  },
  [variants.HIGHLIGHT]: {
    background: colors.buttonBackgroundAlt,
    color: 'text',
  },
  [variants.GRADIENT]: {
    background: colors.gradient.tertiary,
    color: 'text',
  },
  [variants.LIGHT]: {
    background: colors.text,
    color: 'primary',
  },
  [variants.GRAY]: {
    background: '#FFFFFF1F',
    color: 'text',
    border: 0,
    borderRadius: theme.radii.tiny,
  },
  [variants.ERROR]: {
    background: colors.error,
    color: 'text',
  },

  // --------------------- System Design ---------------------

  // Large
  [variants.LARGE_PRIMARY]: {
    background: colors.bg_surface_primary_2,
    ...base[buttonSizes.LARGE],
  },
  [variants.LARGE_SECONDARY]: {
    background: colors.bg_surface_secondary,
    ...base[buttonSizes.LARGE],
  },
  [variants.LARGE_TERTIARY]: {
    ...base[buttonSizes.LARGE],
    background: 'none !important',
  },
  [variants.LARGE_DESTRUCTIVE_PRIMARY]: {
    background: colors.semantic_error,
    ...base[buttonSizes.LARGE],
  },
  [variants.LARGE_DESTRUCTIVE_SECONDARY]: {
    background: colors.bg_surface_secondary,
    ...base[buttonSizes.LARGE],
    color: colors.semantic_error,
  },

  // Small
  [variants.SMALL_PRIMARY]: {
    background: colors.bg_surface_primary_2,
    ...base[buttonSizes.SMALL],
  },
  [variants.SMALL_SECONDARY]: {
    background: colors.bg_surface_secondary,
    ...base[buttonSizes.SMALL],
  },
  [variants.SMALL_TERTIARY]: {
    ...base[buttonSizes.SMALL],
    background: 'none !important',
  },
  [variants.SMALL_DESTRUCTIVE_PRIMARY]: {
    background: colors.semantic_error,
    ...base[buttonSizes.SMALL],
  },
  [variants.SMALL_DESTRUCTIVE_SECONDARY]: {
    background: colors.bg_surface_secondary,
    ...base[buttonSizes.SMALL],
    color: colors.semantic_error,
  },
}

export const styleScales = {
  [scales.SM]: {
    height: '30px',
  },
  [scales.MD]: {
    height: '46px',
  },
  [scales.LG]: {
    height: '55px',
  },
}
